// SingleBugCards.js
import React, { useState, useEffect } from 'react';
import SearchBar from "../../components/BugBounty/SearchBar";
import BugList from "../../components/BugBounty/BugList";
import Filters from "../../components/BugBounty/Filters";
import Alert from '@mui/material/Alert';
// Removed unused import: useHistory
import ENDPOINT from '../../data/ENDPOINT';
import axios from 'axios';
import SecurityHeaders from '../../data/SecurityHeaders';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const SingleBugCards = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [programs, setPrograms] = useState([]);
  const [category, setCategory] = useState(null);

  const getBugs = async () => {
    try {
      let response;
      if (category !== null && category !== '') {
        response = await axios.get(`${ENDPOINT}fetch-bounties.php?category=${category}`, SecurityHeaders);
      } else {
        response = await axios.get(`${ENDPOINT}fetch-bounties.php`, SecurityHeaders);
      }
      
      if (response.status === 200) {
        if (response.data.status === "success") {
          setPrograms(response.data.bounties);
        } else {
          console.error("Error fetching data: ", response.data.message);
        }
      } else {
        console.error("Error fetching data: ", response.data.message);
      }
    }
    catch (error) {
      console.error("Fetch error: ", error);
    }
  }

  useEffect(() => {
    getBugs();
  }, [category]); // Added category as a dependency to refetch when it changes

  const filteredPrograms = programs.filter(program =>
    program.bounty_title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className='min-vh-100 container'>
      <div className='my-4 '>
        <Alert severity="error">This page is under maintenance and will be fully functional from 7th Feb 2025. Kindly visit after 7th to access Bug Bounty Programs.</Alert>
      </div>

      <SearchBar onSearch={setSearchTerm} />

      <div className="container mt-3 p-0 ">
        <div className="d-flex overflow-x-auto ">
          <button onClick={(e) => { setCategory('all'); e.preventDefault() }} className="btn btn-outline-primary ">All Filters</button>
          <button onClick={(e) => { setCategory('rewards'); e.preventDefault() }} className="btn btn-outline-secondary ms-2">Rewards</button>
          <button onClick={(e) => { setCategory('scope'); e.preventDefault() }} className="btn btn-outline-secondary ms-2">Scope</button>
          <button onClick={(e) => { setCategory(null); e.preventDefault() }} className="btn btn-outline-secondary ms-2">Target Category</button>
          <button onClick={(e) => { setCategory(null); e.preventDefault() }} className="btn btn-outline-secondary ms-2">Dates</button>
        </div>
      </div>
      <BugList programs={filteredPrograms} />
    </div>
  );
};

export default SingleBugCards;